const textDecorationThickness = {
  name: "text-decoration-thickness",
  path: "/text-decoration-thickness",
  title: "Text Decoration Thickness",
  description: "Utilities for controlling the thickness of text decoration lines.",
  value: {
    "text-decoration-thickness": {
      "decoration-thick-auto": "auto",
      "decoration-thick-from-font": "from-font",
      "decoration-thick-<number>":"<number>px",
      "decoration-thick-[<value>]": "<value>",
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="underline decoration-thick-auto">This underline uses auto thickness.</p>
<p class="underline decoration-thick-from-font">This underline uses from-font thickness.</p>
<p class="underline decoration-thick-2">This underline uses from-font thickness.</p>
<p class="underline decoration-thick-[1rem]">This underline uses from-font thickness.</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">decoration-thick-auto</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">decoration-thick-from-font</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">decoration-thick-thin</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">decoration-thick-thicker</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">decoration-thick-thick</code> to control the thickness of text decoration lines.
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-thick-auto</small>
          <p class="underline decoration-thick-auto text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-thick-from-font</small>
          <p class="underline decoration-thick-from-font text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-thick-2</small>
          <p class="underline decoration-thick-2 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-thick-4 </small>
          <p class="underline decoration-thick-4 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-thick-[1rem]</small>
          <p class="underline decoration-thick-[1rem] text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
      `
    }
  ]
};

export default textDecorationThickness;
<div className="underline decoration-thick-auto decoration-thick-from-font decoration-thick-2 decoration-thick-4 decoration-thick-[1rem]  sr-only"></div>